import React from 'react';
import { Modal } from './Modal';
import { usePet } from '../context/PetContext';
import { useLanguage } from '../functions/useLanguage';
import AppButton from './AppButton';

/**
 * Top-level dialog shown when the active user has been removed as a co-carer
 * from one or more pets. The notice docs are written by the
 * `onPetMemberDeleted` Cloud Function. Acknowledging the dialog deletes the
 * notice (and the shared pet has already been removed from the carer's
 * shared_pet_refs by the same trigger, so it disappears from the UI).
 */
export default function RemovedPetNoticeDialog() {
  const { removedPetNotices, dismissRemovedPetNotice } = usePet();
  const { t } = useLanguage();

  const notice = removedPetNotices[0];
  if (!notice) return null;

  const title = t('coCarer.removedNotice.title');
  const body = t('coCarer.removedNotice.body').replace('{petName}', notice.pet_name || '');

  return (
    <Modal
      open={true}
      title={title}
      onClose={() => { void dismissRemovedPetNotice(notice.pet_id); }}
      footer={
        <AppButton onClick={() => { void dismissRemovedPetNotice(notice.pet_id); }} className="p-3">
          {t('coCarer.removedNotice.ok')}
        </AppButton>
      }
    >
      <p className="text-sm text-text-secondary leading-relaxed">{body}</p>
    </Modal>
  );
}
